import { useEffect, useState } from 'react';

import './Style.css';
import ModalTrigger from '../../../shared/modal/ModalTrigger';
import { NumberSelect } from '../numberSelect/NumberSelect';

type MultipleNumberSelectProps = {
  assessmentValues?: Record<string, string>;
  fadeIn?: string;
  modalText?: string;
  options: {
    id: string;
    limit: string;
    trailingText: string;
  }[];
  questionid: string;
  questionTitle: string;
  width: string;
  onOpenModal?: () => void;
  onSetValue: (value: { id: string; value: string }) => void;
};

export function MultipleNumberSelect({
  assessmentValues,
  fadeIn,
  modalText,
  options,
  questionid,
  questionTitle,
  width,
  onOpenModal,
  onSetValue,
}: MultipleNumberSelectProps) {
  const [blockOpacity, setBlockOpacity] = useState(0);

  useEffect(() => {
    setTimeout(function () {
      setBlockOpacity(1);
    }, 100);
  });

  return (
    <div className={`question_block${width}`} style={{ opacity: fadeIn ? blockOpacity : '1' }}>
      <fieldset id={questionid} data-input-type="multiple_number_select">
        <legend className="assessment_question_title">{questionTitle}</legend>
        {modalText && (
          <ModalTrigger
            modalText={modalText}
            onOpenModal={onOpenModal}
            question={questionid}
            questionTitle={questionTitle}
          />
        )}
        <div className="answer_block multiple_number_select">
          {options.map((option) => {
            return (
              <NumberSelect
                key={option.id}
                questionid={option.id}
                minlimit="0"
                maxlimit={option.limit}
                trailingText={option.trailingText}
                onSetValue={onSetValue}
                assessmentValues={assessmentValues}
                controlsInfo={option.trailingText}
              />
            );
          })}
        </div>
      </fieldset>
    </div>
  );
}
